export default {
  name: "StarSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    "fill-rule": "evenodd",
    d:
      "M16.97 2.68a1.05 1.05 0 0 0-1.95 0l-3.24 7.88c-.15.37-.5.62-.89.65l-8.42.68c-.94.08-1.31 1.26-.6 1.87l6.41 5.55c.3.26.43.67.34 1.06l-1.96 8.3c-.22.92.78 1.65 1.58 1.16l7.21-4.45c.34-.21.76-.21 1.1 0l7.21 4.45c.8.49 1.79-.23 1.58-1.16l-1.96-8.3c-.09-.39.04-.8.34-1.06l6.41-5.55c.71-.62.33-1.8-.6-1.87l-8.42-.68c-.39-.03-.74-.28-.89-.65l-3.25-7.88z",
    "clip-rule": "evenodd",
  },
}
